
export function sessionStorageGet(key: string) {
  if (typeof window === 'undefined') {
    return null
  }
  const result = sessionStorage.getItem(key) || ''
  try {
    return JSON.parse(result)
  }
  catch (error) {
    return null
  }
}

export function sessionStorageSet(key: string, value: unknown): void {
  if (typeof window === 'undefined') {
    return
  }
  sessionStorage.setItem(key, JSON.stringify(value))
}

export function sessionStorageRemove(key: string): void {
  if (typeof window === 'undefined') {
    return
  }
  sessionStorage.removeItem(key)
}
